/**
 * Density preference (R-13 wow, flag wow.density; spec Amendment C): compact (the default, the
 * spec's 28px controls) or comfortable (the [data-density="comfortable"] token set), remembered per
 * user in this browser the way the drawer width is, applied on <html>.
 */
export type Density = 'compact' | 'comfortable';

const key = (userId: string | null | undefined) => `cigs.kit.density.${userId ?? 'anon'}`;

export function readDensity(userId: string | null | undefined): Density {
  try {
    return localStorage.getItem(key(userId)) === 'comfortable' ? 'comfortable' : 'compact';
  } catch {
    return 'compact';
  }
}

export function writeDensity(userId: string | null | undefined, d: Density): void {
  try {
    localStorage.setItem(key(userId), d);
  } catch {
    /* storage blocked: lasts for this page */
  }
}

/** Puts the density on <html>; compact removes the attribute (the default token set). */
export function applyDensity(d: Density): void {
  if (typeof document === 'undefined') return;
  if (d === 'comfortable') document.documentElement.setAttribute('data-density', 'comfortable');
  else document.documentElement.removeAttribute('data-density');
}
